import React from 'react';
import { useFormik } from 'formik';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Input from 'components/system/Input';
import { redeemCoupon } from 'api/services/payments';
import { redeemCouponSchema } from 'schemas/billing.schema';
import withNotification from 'components/hoc/withNotification';
import colors from 'styles/colors';

const styles = {
  couponCodeInput: {
    marginRight: '10px',
    flex: '1 1 0px',
  },
  submitButton: {
    marginTop: '10px',
    flex: '1 1 0px',
  },
  error: {
    color: colors.error.main,
    lineHeight: '30px',
  },
};

const initialValues = {
  couponCode: '',
};

const RedeemCoupon = ({ onRedeemUpdate }) => {
  const formik = useFormik({
    initialValues,
    validationSchema: redeemCouponSchema,
    onSubmit: async ({ couponCode }, formikHelpers) => {
      const { success, error } = await redeemCoupon(couponCode);
      if (success) {
        onRedeemUpdate();
      } else {
        formikHelpers.setErrors({ couponCode: error });
      }
    },
  });

  return (
    <Box component="form" sx={{ width: '420px' }}>
      <Typography
        variant="h5"
        sx={{
          color: colors.text.primary,
          marginBottom: '25px',
          textAlign: 'center',
        }}
      >
        Redeem a Coupon
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Input
          sx={styles.couponCodeInput}
          autoComplete="off"
          label="Coupon Code"
          name="couponCode"
          value={formik.values.couponCode}
          onChange={formik.handleChange}
        />
        <LoadingButton
          fullWidth
          onClick={formik.handleSubmit}
          variant="contained"
          type="primary"
          loading={formik.isSubmitting}
          disabled={formik.isSubmitting}
          loadingPosition="end"
          sx={styles.submitButton}
        >
          Redeem
        </LoadingButton>
      </Box>
      <Typography variant="caption" sx={styles.error}>
        {formik.touched.couponCode && formik.errors.couponCode}
      </Typography>
    </Box>
  );
};

export default withNotification(RedeemCoupon);
